import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { Constante } from '../../constante';

@Component({
    selector: 'app-admin-layout',
    standalone: true,
    imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
    template: `
    <div class="min-h-screen md:flex" style="background-color: #fff7f9;">
      <aside class="hidden md:flex w-64 shrink-0 text-white p-6 flex-col" style="background-color: var(--bg-main);">
        <div class="mb-8">
          <p class="text-[11px] uppercase tracking-[0.2em] text-white/70">Empresa</p>
          <h1 class="font-black text-2xl leading-tight mt-1">Panel</h1>
        </div>
        <nav class="flex flex-col gap-1 text-sm font-semibold">
          <p class="px-3 pt-2 pb-1 text-[10px] uppercase tracking-widest text-white/50">Ventas</p>
          <a routerLink="/admin/pedidos" routerLinkActive="bg-white/20" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Pedidos</a>
          <a routerLink="/admin/usuarios" routerLinkActive="bg-white/20" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Usuarios y roles</a>
          <p class="px-3 pt-2 pb-1 text-[10px] uppercase tracking-widest text-white/50">Catálogo</p>
          <a routerLink="/admin/productos" routerLinkActive="bg-white/20" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Productos</a>
          <a routerLink="/admin/categorias" routerLinkActive="bg-white/20" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Categorías</a>
          <p class="px-3 pt-4 pb-1 text-[10px] uppercase tracking-widest text-white/50">Empresa</p>
          <a routerLink="/admin/empresa" routerLinkActive="bg-white/20" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Datos</a>
          <a routerLink="/admin/taller" routerLinkActive="bg-white/20" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Taller y horario</a>
          <a routerLink="/admin/pagos" routerLinkActive="bg-white/20" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Yape / Plin</a>
          <a routerLink="/admin/capacidad" routerLinkActive="bg-white/20" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Cupos de entrega</a>
        </nav>
        <div class="mt-auto pt-6 border-t border-white/15 flex flex-col gap-1 text-sm">
          <a routerLink="/" class="px-3 py-2.5 rounded-2xl hover:bg-white/10">Ver tienda</a>
          <button type="button" (click)="logout()" class="text-left px-3 py-2.5 rounded-2xl hover:bg-white/10">Cerrar sesión</button>
        </div>
      </aside>

      <div class="flex-1 min-w-0">
        <header class="bg-white/90 backdrop-blur border-b border-rose-100 px-4 md:px-8 py-4 flex items-center justify-between gap-3 sticky top-0 z-20">
          <div class="flex items-center gap-3">
            <button type="button" class="md:hidden w-10 h-10 rounded-2xl text-white" style="background-color: var(--bg-main);" (click)="mobileOpen.set(!mobileOpen())">☰</button>
            <div>
              <p class="text-xs text-gray-400">Hola</p>
              <p class="text-sm font-bold text-gray-800 leading-tight">{{ auth.session()?.nombreVisible }}</p>
            </div>
          </div>
          <a routerLink="/" class="text-sm font-semibold text-rose-500 hover:underline">Ir a la tienda</a>
        </header>

        <div *ngIf="mobileOpen()" class="md:hidden bg-white border-b border-rose-100 px-4 py-3 flex flex-col gap-1 text-sm font-semibold">
          <a routerLink="/admin/pedidos" (click)="mobileOpen.set(false)" class="px-3 py-2 rounded-xl hover:bg-rose-50">Pedidos</a>
          <a routerLink="/admin/usuarios" (click)="mobileOpen.set(false)" class="px-3 py-2 rounded-xl hover:bg-rose-50">Usuarios y roles</a>
          <a routerLink="/admin/productos" (click)="mobileOpen.set(false)" class="px-3 py-2 rounded-xl hover:bg-rose-50">Productos</a>
          <a routerLink="/admin/categorias" (click)="mobileOpen.set(false)" class="px-3 py-2 rounded-xl hover:bg-rose-50">Categorías</a>
          <a routerLink="/admin/empresa" (click)="mobileOpen.set(false)" class="px-3 py-2 rounded-xl hover:bg-rose-50">Datos de empresa</a>
          <a routerLink="/admin/taller" (click)="mobileOpen.set(false)" class="px-3 py-2 rounded-xl hover:bg-rose-50">Taller y horario</a>
          <a routerLink="/admin/pagos" (click)="mobileOpen.set(false)" class="px-3 py-2 rounded-xl hover:bg-rose-50">Yape / Plin</a>
          <a routerLink="/admin/capacidad" (click)="mobileOpen.set(false)" class="px-3 py-2 rounded-xl hover:bg-rose-50">Cupos de entrega</a>
          <button type="button" (click)="logout()" class="text-left px-3 py-2 rounded-xl hover:bg-rose-50">Cerrar sesión</button>
        </div>

        <main class="p-4 md:p-8 max-w-6xl">
          <router-outlet />
        </main>
      </div>
    </div>
    `
})
export class AdminLayoutComponent {
    auth = inject(AuthService);
    mobileOpen = signal(false);

    logout() {
        this.auth.logout();
        location.href = Constante.URL_HOME;
    }
}
